import React from 'react'

function PendingPayments() {
  return (
    <div>
      pending payment
    </div>
  )
}

export default PendingPayments
